import items from "./items";
export default {
  text: "Master Data",
  key: "title.masterData",
  level: 1,
  items: items
};